import { Injectable } from '@angular/core';

@Injectable()
export class AppConstants {

  static baseUrl = window.location.hostname;

  // for local development
  // static baseUrl = 'dev.bxbdigital.com';


  private static config:any = {
  	'dev': {
  		clientId: '0oai8qwy6dBs8tHDT0h7',
  		baseUrl: 'https://dev-987520.oktapreview.com'//https://dev-987520.oktapreview.comoauth2/default/.well-known/webfinger
  	},
  	'local': {
  		clientId: '0oai8qwy6dBs8tHDT0h7',
  		baseUrl: 'https://dev-987520.oktapreview.com'
  	},
    'dev1': {
  		clientId: '0oai8qwy6dBs8tHDT0h7',
  		baseUrl: 'https://dev-987520.oktapreview.com'
  	},
  	'test': {
  		clientId: '0oayut1xF7gFkOitZ415',
  		baseUrl: 'https://bxbd-us-test.okta.com'
  	},
  	'stg': {
  		clientId: '0oamaahx68cZYPLsp4x5',
  		baseUrl: 'https://bxbd-stg-us.okta.com'
  	},
    'stg2': {
      clientId: '0oa1olmilFiLGsLA1416',
      baseUrl: 'https://bxbd-stg-eu.okta.com'
    },
  	'apps': {
  		clientId: '0oa1hsl6dz66eT1w20h8',
  		baseUrl: 'https://bxbd-us.okta.com'
  	},
    'apps-euc': {
      clientId: '0oae8spjh3KckAFwf417',
      baseUrl: 'https://bxbd-eu.okta.com'
    },
    'apps-usw': {
      clientId: '0oa1x4qcbhsoxGeym0h8',
      baseUrl: 'https://bxbd-us.okta.com'
  	},
    'apps2': {
      clientId: '0oa1wi2nklnkxkyQg416',
      baseUrl: 'https://bxbd-eu.okta.com'
    },
    'perf': {
      clientId: '0oa3mqrn4qMWU9fSm4x7',
      baseUrl: 'https://bxbd-stg-eu.okta.com'
    }
  };

  private static env = AppConstants.baseUrl.split('.')[0];
  constructor() {
  }

  public static getClientId() {
  	return this.config[this.env].clientId;
  }

  public static getIssuer() {
  	return this.config[this.env].baseUrl + '/oauth2/default';
  }

  public static getBaseUrl() {
  	return this.config[this.env].baseUrl;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/constants/app.constants.ts